import { makeStyles } from '@material-ui/core';

export const getProposalEditorSideBarSectionsListDroppableContainerStyles =
  makeStyles(() => ({
    container: {
      width: '100%',
      margin: 'auto',
    },
  }));
